export default __webpack_public_path__ + "static/korea_trust-a606d0b68ba138863085f1503dad5d27.png";